import { ApolloLink } from '@apollo/client/core';
import { formatLocaleCMS } from '../utils/format-locale-cms';

export function createCmsLocaleMiddleware(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const variables = operation.variables;
    if (variables['locale']) {
      variables['locale'] = formatLocaleCMS(variables['locale']);
    }
    if (variables['countryName']) {
      if (operation.operationName === 'SearchFilters') {
        // Search selects a country (at), independently of the content locale (de_AT).
        const countries = Array.isArray(variables['countryName'])
          ? variables['countryName'] : [variables['countryName']];
        variables['countryName'] = countries.map(country => formatLocaleCMS(country));
      } else {
        // Other callers still rely on the legacy locale-based market selection.
        variables['countryName'] = [formatLocaleCMS(variables['locale'])];
      }
    }
    variables['buildversion'] = '3299900024';
    return forward(operation);
  });
}
